import { ValueOf } from '../utilities/types';

const includeSheets = {
  CASE_LIST: 'caseList',
  PING_LIST: 'pingList',
  REQUEST_LIST: 'requestList',
  CUSTOM_CONNECTION_LIST: 'customConnectionList',
  SCREENING_LISTS: 'screeningLists',
  GROUP_HISTORY: 'groupHistory',
} as const;

export const includeSheetsChoices = [
  { id: includeSheets.CASE_LIST, name: 'Cases' },
  { id: includeSheets.PING_LIST, name: 'Pings' },
  { id: includeSheets.REQUEST_LIST, name: 'Requests' },
  { id: includeSheets.CUSTOM_CONNECTION_LIST, name: 'Custom Connections' },
  { id: includeSheets.SCREENING_LISTS, name: 'Screening reports' },
  { id: includeSheets.GROUP_HISTORY, name: 'Group history' },
];

export type IncludeSheets = ValueOf<typeof includeSheets>;

export default includeSheets;
